import React from "react";

const Sharpshooter = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Sharpshooter</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Sharpshooter perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Sharpshooter</b> is a class focused on precision and
          high-damage shots, making it one of the most effective roles for
          players who excel at aiming. The Sharpshooter perk emphasizes dealing
          headshot damage from a distance and taking out enemies with accuracy.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Sharpshooter has access to a variety of powerful
          firearms that benefit from the perk's high headshot damage and
          accuracy, such as the Rifles, Pistols or a Crossbow. These weapons
          allow for precise long-range attacks, ideal for taking out enemies
          before they can close the gap.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <ul>
            <li>Bonuses for Sharpshooter weapons:</li>
            <ul>
              <li>Increase in headshot damage;</li>
              <li>Increase in fire speed;</li>
              <li>Increase in reload speed;</li>
              <li>Increase in amount ammunition magazines;</li>
              <li>Increase in pickup amount of ammunition;</li>
              <li>Discount on ammunition;</li>
              <li>Reduced weapon price;</li>
            </ul>
            <li>General bonuses:</li>
            <ul>
              <li>Increase in headshot damage with all weapons;</li>
              <li>Increase in carry weight;</li>
              <li>Increase in recoil control;</li>
            </ul>
          </ul>
        </div>
        <b>Team Role</b>: Sharpshooters work well in teams where they can focus
        on eliminating distant targets. Their ability to deal precise headshots
        makes them invaluable against tougher enemies.
      </div>
    </div>
  );
};

export default Sharpshooter;
